import { useTranslation } from 'react-i18next'

import { OpeningSteps } from 'sections/PromoSection/components/OpeningSteps/OpeningSteps'
import { Title } from 'components/ui/Title/Title'

import { PromoPageKeys } from '../../../types'

import s from './OpeningStepsSection.module.scss'

interface StepData {
  desktopImage: string
  mobileImage: string
  tabletImage: string
  title: string
  caption?: string | null
}

interface OpeningStepsProps {
  stepsData: StepData[]
}

export const OpeningStepsSection = ({ stepsData }: OpeningStepsProps) => {
  const { t } = useTranslation()
  const getKey = (key: string) => `${PromoPageKeys.openingSteps}.${key}`

  return (
    <section className={s.OpeningSteps}>
      <Title className={s.title} fontWeight={700} textAlign="center">
        {t(getKey('Свой бизнес с нуля'), { nbsp: '\u00A0' })}
      </Title>
      <OpeningSteps stepsData={stepsData} />
    </section>
  )
}
